import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface PasswordResetStore {
  passwordResetToken: string | undefined;
}

export const usePasswordResetDataStore = create<PasswordResetStore>()(
  persist(
    (set) => {
      return {
        passwordResetToken: undefined,
      };
    },
    {
      name: "password-reset-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
